import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { EndpointsIntegrations } from '../integrations-flow/EndpointsIntegrations';
import { EndpointsStandaloneCmsPartner } from './EndpointsStandaloneCmsPartner';
import { EndpointsUserOnlyFlow } from './http-user-only-signup/EndpointsUserOnlyFlow';
import { EndpointDIST030 } from './EndpointsDIST030';
export const getFlowEndpointOverrides = () => {
  switch (getFlowKey()) {
    case Flow.Integrations:
      return EndpointsIntegrations;
    case Flow.StandaloneCmsPartner:
      return EndpointsStandaloneCmsPartner;
    case Flow.Connect:
    case Flow.ChatSpot:
      return EndpointsUserOnlyFlow;
    case Flow.Microapp:
      return EndpointDIST030;
    default:
      return {};
  }
};